import { createContext } from 'react';
import { GlobalNavigationProps } from './global-navigation.types';

export const GlobalNavigationContext = createContext<Pick<GlobalNavigationProps, 'open'>>({ open: true });
